export default "__VITE_ASSET__BxIu7ZpM__"